import { BrowserRouter, Navigate, Routes, Route } from 'react-router-dom';
import { useEffect, useState } from 'react';

import GlobalStyles from './styles/GlobalStyles';

import Navbar from './components/layout/Navbar';
import Footer from './components/layout/Footer';
import ScrollManager from './components/layout/ScrollManager';

import Home from './pages/Home';
import Impressum from './pages/Impressum';
import Datenschutz from './pages/Datenschutz';

function App() {
  const [language, setLanguage] = useState('de');

  useEffect(() => {
    document.documentElement.lang = language;
  }, [language]);

  return (
    <BrowserRouter>
      <GlobalStyles />
      <ScrollManager />

      <Navbar language={language} setLanguage={setLanguage} />

      <Routes>
        <Route path="/" element={<Home language={language} />} />
        <Route path="/impressum" element={<Impressum language={language} />} />
        <Route path="/datenschutz" element={<Datenschutz language={language} />} />
        <Route path="*" element={<Navigate to="/" replace />} />
      </Routes>

      <Footer language={language} />
    </BrowserRouter>
  );
}

export default App;
